export default {
  INQUIRYFORM_QUERYITEM_BUSINESSTYPE: {
    key: 'inquiryform_queryitem_businesstype',
    label: '查询项 - 业务类型下拉'
  },
  INQUIRYFORM_QUERYITEM_DOCUMENTTYPE: {
    key: 'inquiryform_queryitem_documenttype',
    label: '查询项 - 单据类型下拉'
  },
  INQUIRYFORM_QUERYITEM_DOCUMENTNUMBER: {
    key: 'inquiryform_queryitem_documentnumber',
    label: '查询项 - 单据号输入框'
  },
  INQUIRYFORM_QUERYITEM_INQUIRYSTATUS: {
    key: 'inquiryform_queryitem_inquirystatus',
    label: '查询项 - 咨询单状态下拉'
  },
  INQUIRYFORM_QUERYITEM_DATE: {
    key: 'inquiryform_queryitem_date',
    label: '查询项 - 日历选择按钮'
  },
  INQUIRYFORM_QUERYITEM_INQUIRE: {
    key: 'inquiryform_queryitem_inquire',
    label: '查询项 - 查询按钮'
  },
  INQUIRYFORM_QUERYITEM_RESET: {
    key: 'inquiryform_queryitem_reset',
    label: '查询项 - 重置按钮'
  },
  INQUIRYFORM_CREATE: {
    key: 'inquiryform_create',
    label: '创建咨询单按钮'
  },
  INQUIRYFORM_CREATE_BATCH: {
    key: 'inquiryform_create_batch',
    label: '批量创建咨询单按钮'
  },
  INQUIRYFORM_EXPORT: {
    key: 'inquiryform_export',
    label: '导出按钮'
  },
  INQUIRYFORM_DETAILS: {
    key: 'inquiryform_details',
    label: '列表 - 详情按钮'
  },
  INQUIRYFORM_REMINDERS: {
    key: 'inquiryform_reminders',
    label: '列表 - 催单按钮'
  },
  INQUIRYFORM_CANCEL: {
    key: 'inquiryform_cancel',
    label: '列表 - 取消按钮'
  },
  INQUIRYFORM_WAYBILLNUMBERLINK: {
    key: 'inquiryform_waybillnumberlink',
    label: '列表 - 运单号链接（可跳转的）'
  },
  INQUIRYFORM_DOCUMENTNUMBERLINK: {
    key: 'inquiryform_documentnumberlink',
    label: '单据号链接（可跳转的）'
  },
  INQUIRYFORM_DETAILS_CANCEL: {
    key: 'inquiryform_details_cancel',
    label: '取消咨询单按钮（待回复）'
  },
  INQUIRYFORM_DETAILS_REMINDERS: {
    key: 'inquiryform_details_reminders',
    label: '催单按钮（待回复）'
  },
  INQUIRYFORM_DETAILS_UPLOADCERTIFICATE: {
    key: 'inquiryform_details_uploadcertificate',
    label: ' 上传凭证按钮'
  },
  INQUIRYFORM_DETAILS_SUBMIT: {
    key: 'inquiryform_details_submit',
    label: '提交按钮'
  },
  INQUIRYFORM_DETAILS_DOWNLOAD: {
    key: 'inquiryform_details_download',
    label: '已上传附件的下载按钮'
  },
  INQUIRYFORM_DETAILS_SOLVED: {
    key: 'inquiryform_details_solved',
    label: '已解决按钮'
  },
  INQUIRYFORM_DETAILS_UNSOLVED: {
    key: 'inquiryform_details_unsolved',
    label: '未解决按钮'
  },
  INQUIRYFORM_CREATE_WAYBILLINTERCEPTION: {
    key: 'inquiryform_create_waybillinterception',
    label: '运单拦截按钮'
  },
  INQUIRYFORM_CREATE_WAYBILLMODIFICATION: {
    key: 'inquiryform_create_waybillmodification',
    label: '运单修改按钮'
  },
  INQUIRYFORM_CREATE_UPLOADCERTIFICATE: {
    key: 'inquiryform_create_uploadcertificate',
    label: '上传凭证按钮'
  },
  INQUIRYFORM_CREATE_SUBMIT: {
    key: 'inquiryform_create_submit',
    label: '提交按钮'
  },
  INQUIRYFORM_CREATE_TIME: {
    key: 'inquiryform_create_time',
    label: '创建咨询单时间'
  }
}
